import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { UserMadFullFragment, USER_MAD_FULL_FRAGMENT } from "../../fragments";
import { UserQueryVariables } from "../../types";

export const GET_USER = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      ...UserMadFullFragment
    }
  }
  ${USER_MAD_FULL_FRAGMENT}
`;

export type UserData = { user: UserMadFullFragment };

export default (options?: QueryHookOptions<UserData, UserQueryVariables>) => {
  return useQuery<UserData, UserQueryVariables>(GET_USER, options);
};
